import React,{useState,useEffect}from 'react'
import { Modal, Form, Input, Button, Space, App, Table, Radio, Flex } from 'antd';
import Main from '../../cpn/Main'
import { useIncomeExpenditureHxListQuery, useIncomeExpenditureHxSaveMutation,} from '../../store/ReactWebSiteApi';
import { useNavigate } from 'react-router-dom';
import ArapQuery from './ArapQuery';
import LedgerCheck from '../ledger/LedgerCheck';
import {LogoutOutlined} from '@ant-design/icons';
import ArapStatement from './ArapStatement';
import BalanceCheck from '../balance/BalanceCheck';
import BalanceAuditTag from '../balance/BalanceAuditTag';
import ArapQueryModal from './ArapQueryModal';
function ArapAddOld() {
    const { message } = App.useApp();
    const [form] = Form.useForm();  
    //新增下账--------------------------------------------------------------------------------------------------------------------------------------------新增下账//
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loading, setLoading] = useState(false);
    const start = () => {
        setLoading(true);
        // ajax request after empty completing
        setTimeout(() => {
        setSelectedRowKeys([]);
        setLoading(false);
        }, 1000);
    };
    const onSelectChange = (newSelectedRowKeys,f) => {
        console.log(newSelectedRowKeys,f);
        if(f.length>1){
            if(f[f.length - 1].ec_id !== f[f.length - 2].ec_id){
                message.error('新增下账的客户必须相同！')
                return false;
            }
        }

        let sum3 
        sum3 = f.reduce((sum3, obj) => (sum3 += +obj.eie_amount), 0)
        setInfo(prevState=>({...prevState,eie_hx_amount:sum3,eie_id:newSelectedRowKeys+'',ec_name:f[0]?f[0].ec_name:''}))        
        console.log('selectedRowKeys changed: ', newSelectedRowKeys);
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        getCheckboxProps: (record) => ({
            disabled: (record.eie_hx_amount && record.eie_hx_amount !== '0.00'),
            // Column configuration not to be checked
            name: record.name,
        }),
    };
    const hasSelected = selectedRowKeys.length > 0;
    const [info,setInfo] = useState({
        ecal_uid:localStorage.getItem('eu_id'),
        ecal_uname:localStorage.getItem('eu_name'),
        eie_hx_content:'',
        eie_hx_amount:0,
    });
    const [submitAudit] = useIncomeExpenditureHxSaveMutation()
    const [open, setOpen] = useState(false);
    const navi = useNavigate();
    const modalCheck = <Modal
                            open={open}
                            title='新增下账'
                            okText="提交"
                            cancelText="取消"
                            onCancel={() => {setOpen(false);}}
                            onOk={() => {
                                form
                                    .validateFields()
                                    .then((values) => {
                                        form.resetFields();
                                        submitAudit({
                                            eie_id:info.eie_id,
                                            eie_hx_uid:localStorage.getItem('eu_id'),
                                            eie_hx_uname:localStorage.getItem('eu_name'),
                                            eie_hx_amount:info.eie_hx_amount,
                                            eie_hx_content:info.eie_hx_content,
                                        }).then((res) => {
                                            console.log(res);
                                            if (res.data.Status === 'success') {
                                                setOpen(false)
                                                message.success('新增下账成功！')   
                                                start()     
                                                localStorage.setItem('arapWait_query_dept','')
                                                localStorage.setItem('arapWait_query_client','')
                                                localStorage.setItem('arapWait_query_team_num','')
                                                localStorage.setItem('arapWait_query_date_s','')
                                                localStorage.setItem('arapWait_query_date_e','')
                                                localStorage.setItem('arapWait_query_action','')
                                                localStorage.setItem('arapWait_query_ysyf_type','')
                                                localStorage.setItem('arapWait_query_eie_type_id','')
                                                localStorage.setItem('arapWait_query_eie_finance_sub_type_id','')
                                                setQuery(prevState=>({
                                                    ...prevState,
                                                    action:'',
                                                    ysyf_type:'',
                                                    eie_client_id:'',
                                                    eie_arrive_date_s:'',
                                                    ebn_team_num:'',
                                                    eie_dept_id:'',
                                                    ebn_date_s:'',
                                                }))
                                            }
                                            if (res.data.Status === 'fail') {
                                                message.error('新增下账失败！'+res.data.Message)
                                            }
                                        })
                                    })
                                    .catch((info) => {
                                        console.log('Validate Failed:', info);
                                    });                               

                            }}
                        >
                            <Form
                                form={form}
                                layout="horizontal"
                                name="form_in_modal"
                                initialValues={{modifier: 'public',}}
                                labelCol={{ span: 5 }}                                
                            >                                
                                <Form.Item label='客户名称' wrapperCol={{span:15}} style={{marginBottom:"0"}}>
                                    {info.ec_name}
                                </Form.Item>
                                <Form.Item label='收支数量' wrapperCol={{span:15}} style={{marginBottom:"0"}}>
                                    {selectedRowKeys.length + '笔'}
                                </Form.Item>
                                <Form.Item label='金额合计' wrapperCol={{span:15}} style={{marginBottom:"0"}}>
                                    {info.eie_hx_amount.toFixed(2)}
                                </Form.Item>
                                <Form.Item name="content" label='下账备注' wrapperCol={{span:15}} style={{marginBottom:"0"}} >
                                    <Input onChange={(e) => {setInfo(prevState=>({...prevState,eie_hx_content:e.target.value}))}}/>
                                </Form.Item>                                                       
                            </Form>
                        </Modal> 
    
     //当前页码
     const [current, setCurrent] = useState(localStorage.getItem('arapWait_query_page')?localStorage.getItem('arapWait_query_page'):'1');
     //当前每页数量
     const [pageSize,setPageSize] = useState(localStorage.getItem('arapWait_query_page_size')?localStorage.getItem('arapWait_query_page_size'):"50")

    const [query,setQuery] = useState({
        eie_e_id:localStorage.getItem('e_id'),
        eie_client_id:localStorage.getItem('arapWait_query_client')?localStorage.getItem('arapWait_query_client'):'',
        action:localStorage.getItem('arapWait_query_action')?localStorage.getItem('arapWait_query_action'):'',
        hx_type:'2',
        eie_arrive_date_s:'',
        eie_arrive_date_e:'',
        eie_dept_id:localStorage.getItem('arapWait_query_dept')?localStorage.getItem('arapWait_query_dept'):'', 
        ebn_team_num:localStorage.getItem('arapWait_query_team_num')?localStorage.getItem('arapWait_query_team_num'):'',
        ysyf_type:localStorage.getItem('arapWait_query_ysyf_type')?localStorage.getItem('arapWait_query_ysyf_type'):'',
        ebn_date_s:localStorage.getItem('arapWait_query_date_s')?localStorage.getItem('arapWait_query_date_s'):'',
        ebn_date_e:localStorage.getItem('arapWait_query_date_e')?localStorage.getItem('arapWait_query_date_e'):'',
        eie_jbr_uid:'',
        eu_id:localStorage.getItem('eu_id'),
        eie_state:'2',
        eie_type_id:localStorage.getItem('arapWait_query_eie_type_id')?localStorage.getItem('arapWait_query_eie_type_id'):'',                                
        eie_finance_sub_type_id:localStorage.getItem('arapWait_query_eie_finance_sub_type_id')?localStorage.getItem('arapWait_query_eie_finance_sub_type_id'):'',      
    });
    const getQuery = (e) => {
        setQuery(prevState=>({
            ...prevState,            
            action:e.action,
            eie_client_id:e.eie_client_id?e.eie_client_id:'',
            ebn_team_num:e.ebn_team_num?e.ebn_team_num:'',
            ysyf_type:e.ysyf_type?e.ysyf_type:'',
            eie_dept_id:e.eie_dept_id?e.eie_dept_id:'',
            ebn_date_s:e.ebn_date_s?e.ebn_date_s:'',
            ebn_date_e:e.ebn_date_e?e.ebn_date_e:'',
            eie_state:'2',
            eie_type_id:e.eie_type_id?e.eie_type_id:'',                                
            eie_finance_sub_type_id:e.eie_finance_sub_type_id?e.eie_finance_sub_type_id:'',      
        }))
    }
    
    const {data,isSuccess} = useIncomeExpenditureHxListQuery(query,{refetchOnMountOrArgChange:1})
    
    const [list, setList] = useState();
    
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                const newArr = data.Result.map(item => {
                    const {eie_id:key,eie_esv_id,ebn_client_id,ebn_id,ebn_dept_id,ebn_date,eg_name,ebn_yw_name,ed_name,eie_type_id,eie_finance_sub_type_name,ec_id,ebn_team_num,eie_amount,ec_name,eie_hx_amount,eie_hx_ctime,eie_hx_number,eie_hx_uname,eie_year,eie_eg_id,eie_ebn_id,eie_content,eie_uname,eie_ctime,eie_update_ctime,eie_update_uname,eie_price,eie_image_file,eie_count,eci_name,eu_name,eie_audit1_uname,eie_audit2_uname,eie_audit3_uname,eie_audit4_uname,eie_audit1_ctime,eie_audit2_ctime,eie_audit3_ctime,eie_audit4_ctime} = item;
                    let type = ''
                        switch (eie_type_id) {
                            case '1'://销售收入
                            type = '团队收入'
                                break;
                            case '2'://成本支出
                            type = '团队支出'
                                break;
                            case '3'://费用支出
                            type = '费用支出'
                                break;
                            case '4'://其他收入
                            type = '其他收入'
                                break;
                            case '5'://其他支出
                            type = '其他支出'
                                break;              
                            default:
                                break;
                        }
                    return item = {key,eie_esv_id,ebn_client_id,ebn_id,ebn_dept_id,ebn_date,eg_name,ebn_yw_name,ed_name,eie_type_id,type,eie_finance_sub_type_name,ec_id,ebn_team_num,eie_amount,ec_name,eie_hx_amount,eie_hx_ctime,eie_hx_number,eie_hx_uname,eie_year,eie_eg_id,eie_ebn_id,eie_content,eie_uname,eie_ctime,eie_update_ctime,eie_update_uname,eie_price,eie_image_file,eie_count,eci_name,eu_name,eie_audit1_uname,eie_audit2_uname,eie_audit3_uname,eie_audit4_uname,eie_audit1_ctime,eie_audit2_ctime,eie_audit3_ctime,eie_audit4_ctime}
                })
                const filteredArray = newArr.filter(item => +item.eie_hx_number < 1);                
                const sortArr = filteredArray.sort( (a, b) => {      
                    let aTimeString = a.eie_ctime;
                    let bTimeString = b.eie_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    const columns = [
        {
            key: 'action',
            title: '全选',
            render: (_, record) => {
                return <>
                     <Space>    
                        <BalanceCheck
                            titleType='数字'
                            eie_id={record.key}
                            title={record.type} 
                            eie_type_id={record.eie_type_id}
                            eie_finance_sub_type_id={record.eie_finance_sub_type_id}
                            eie_finance_sub_type_name={record.eie_finance_sub_type_name}
                            eie_ebn_id={record.eie_ebn_id}
                            eie_esv_id={record.eie_esv_id}
                            eie_eg_id={record.eie_eg_id}
                        />
                    </Space>
                </>
            }
        },   
        {
            key: 'client',
            title: '客户',
            dataIndex: 'ec_name',
        }, 
        {
            key: 'pic',
            title: '类型',
            render:(_,recorde) => {
                return <>
                    {recorde.type}-{recorde.eie_finance_sub_type_name}
                </>
            }           
        }, 
        {
            key: 'ebn_team_num',
            title: '团队台账',
            dataIndex: 'ebn_team_num',
            sorter: {
                compare: (a, b) => a.ebn_team_num - b.ebn_team_num,
            },
            render:(text,record) => {
                return  <LedgerCheck 
                            titleType='数字'
                            ebn_id={record.ebn_id} 
                            ebn_dept_id={record.ebn_dept_id}
                            ebn_team_num={record.ebn_team_num}
                        />
            }
        },   
        {
            key: 'ebn_date',
            title: '出发日期',
            dataIndex: 'ebn_date',
        },  
        {
            key: 'ed_name',
            title: '部门',
            dataIndex: 'ed_name',
        },             
        {
            key: 'eg_name',
            title: '产品',
            dataIndex: 'eg_name',
        },  
        // {
        //     key: 'eie_count',
        //     title: '数量',
        //     dataIndex: 'eie_count',
        // },            
        {
            key: 'eie_amount',
            title: '金额',
            dataIndex: 'eie_amount',
        },            
        {
            key: 'ebn_yw_name',
            title: '销售员',
            dataIndex: 'ebn_yw_name',
        },                    
        {
            key: 'eie_content',
            title: '备注',
            dataIndex: 'eie_content',
        },                    
        {
            key: 'status',
            title: '审核',
            width:'6%',
            render:(_,record) => {
                return<>
                    <BalanceAuditTag
                        eie_audit1_uname={record.eie_audit1_uname}
                        eie_audit2_uname={record.eie_audit2_uname}
                        eie_audit3_uname={record.eie_audit3_uname}
                        eie_audit4_uname={record.eie_audit4_uname}
                        eie_audit1_ctime={record.eie_audit1_ctime}
                        eie_audit2_ctime={record.eie_audit2_ctime}
                        eie_audit3_ctime={record.eie_audit3_ctime}
                        eie_audit4_ctime={record.eie_audit4_ctime}
                        direction='vertical'
                    />
                </>
            }
        },                     
    ]
    //搜索样式
    const [searchStyle,setSearchStyle] = useState('1')
    return (
        <Main  t1='下账'>
            <Flex
                justify='space-between'
                align='center'
            >
                <Space>
                    <Button 
                        type="primary" 
                        onClick={() => { 
                            if(!hasSelected){
                                message.error('请选择需要下账的收支单！')
                            }else{
                                setOpen(true);
                            }
                        }}  
                        style={{marginLeft:'10px'}}
                    >
                        新增下账
                    </Button>
                    {hasSelected ? `已选${selectedRowKeys.length}笔，合计${info.eie_hx_amount.toFixed(2)}元` : ''}
                    <Button onClick={start} disabled={!hasSelected} loading={loading} style={{marginLeft:'10px'}}>
                        重置
                    </Button>                 
                     {localStorage.getItem('ArapSearch')==='1' ? <ArapQuery 
                        getQuery={getQuery}
                        eie_dept_id={query.eie_dept_id}
                        query={query}
                    /> :<ArapQueryModal
                            getQuery={getQuery}
                            eie_dept_id={query.eie_dept_id}
                            query={query}
                        /> }
                </Space>
                <Space style={{
                            fontSize:"18px"
                            }}>
                    <a 
                        
                        onClick={() => {
                            navi('/ArapList')
                        }}
                    ><LogoutOutlined /> 已下账列表</a>
                    <ArapStatement />
                </Space>
            </Flex>    
            <Table 
                columns={columns} 
                style={{marginTop:'20px'}} 
                dataSource={list} 
                rowSelection={rowSelection}
                pagination={{
                    showSizeChanger:true,
                    showTotal:(total) => `共${total}条`,
                    current:current,
                    onChange:(e,f) => {
                        setCurrent(e)
                        setPageSize(f)
                        localStorage.setItem('arapWait_query_page',e);
                        localStorage.setItem('arapWait_query_page_size',f);
                    },
                    pageSize:pageSize,
                    showTitle:true,
                }}
            />
            <div style={{textAlign:'right',width:"100%"}}>
                <div>
                    <span>查询样式：</span>
                    <Radio.Group
                        value={searchStyle} 
                        onChange={(e) => {
                            setSearchStyle(e.target.value)
                            localStorage.setItem('LedgerListSearch',e.target.value)
                        }}>
                        <Radio value='1'>平铺式</Radio>
                        <Radio value='2'>弹出式</Radio>
                    </Radio.Group>
                </div>             
            </div>
            {modalCheck}    
        </Main>
    )
}

export default ArapAddOld